import { createClient } from '@supabase/supabase-js'

const supabaseURL = 'https://mtblpkbzvzpmargjnupr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im10Ymxwa2J6dnpwbWFyZ2pudXByIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzkzNDUwMTMsImV4cCI6MTk5NDkyMTAxM30.jKpishbi7JHQN15l6HEswvkFlB1mxAFB6LKeUheRrF4';

export const supabase = createClient(supabaseURL, supabaseAnonKey);